import { CircularProgress } from "@mui/material";

const Loader = () => {
  return (
    <>
      <CircularProgress className="circularProgress" />
    </>
  );
};

export default Loader;
